import { setInfluenceAnalysisMetricFilter as setInfluenceAnalysisMetricFilterDiagram , updateDiagramInfluenceAnalysis} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {
    metricFilter?: Number,
}

export const applyInfluenceAnalysisMetricFilter = ({
    metricFilter,
    eventEmitter,
}: Props) => {
    setInfluenceAnalysisMetricFilterDiagram(metricFilter);
    apiProvider.updateDiagramInfluencers();
    eventEmitter.emit(Event.applyInfluenceAnalysisMetricFilter);
};
